import { Component } from '@angular/core';
import { HeaderLatestComponent } from 'src/app/home/landing-root/header-latest/header-latest.component';
import { PeopleflowFooterComponent } from 'src/app/peopleflow-footer/peopleflow-footer.component';

@Component({
  selector: 'app-attendance-custom-brand',
  imports: [HeaderLatestComponent, PeopleflowFooterComponent],
  templateUrl: './attendance-custom-brand.html',
  styleUrl: './attendance-custom-brand.scss',
})
export class AttendanceCustomBrand {

}
